import * as _ from "underscore";
import { isUndefined } from "./utils";
import { DrEntity } from "./dr-entity";
import { TemplateType } from "./template";

export enum ActionType {
    VIEW = "VIEW",
    DELETE = "DELETE",
    EDIT = "EDIT",
    CREATE = "CREATE",
}

export enum ObjectActionListType {
    ORGANIZATION = 'ORGANIZATION',
    ORGANIZATIONS = 'ORGANIZATIONS',

    ROLE = "ROLE",
    CONNECTOR = "CONNECTOR",
    PROJECT = "PROJECT",
    DOCUMENT_TAGS = "DOCUMENT_TAGS",
    CORPUS = "CORPUS",
    CORPUS_DATA_AREA = "CORPUS_DATA_AREA",
    EXPORT_DB_CONNECTION = "EXPORT_DB_CONNECTION",

    REGULAR_EXPRESSIONS = "REGULAR_EXPRESSIONS",
    AUDIT_LOG = "AUDIT_LOG",
    EXPORT_OPTIONS = "EXPORT_OPTIONS",
    CORPUS_SET = "CORPUS_SET",
    WORKING_SET = "WORKING_SET",
    WORK_BASKET = "WORK_BASKET",
    WORK_BASKET_PERMISSIONS = "WORK_BASKET_PERMISSIONS",
    EMAIL_SIGNATURES = "EMAIL_SIGNATURES",
    WORK_FLOW = "WORK_FLOW",

    VIEW = "VIEW",
    SAVED_SEARCH_QUERY = "SAVED_SEARCH_QUERY",
    MODEL = "MODEL",

    ECA_BATCH = "ECA_BATCH",
    ECA_CASE_DATA = "ECA_CASE_DATA",
    ECA_CUSTODIAN = "ECA_CUSTODIAN",
    ECA_MY_VIEW = "ECA_MY_VIEW",
    ECA_FOLDER = "ECA_FOLDER",
    ECA_MEDIAID = "ECA_MEDIAID",

    SANITIZATION_POLICY = "SANITIZATION_POLICY",
    DOWNLOAD_NATIVES = "DOWNLOAD_NATIVES",

    REVIEW_CHECK_OUT_IN = "REVIEW_CHECK_OUT_IN",
    REVIEW_CODING = "REVIEW_CODING",
    REVIEW_REDACTION = "REVIEW_REDACTION",
    REVIEW_BULK_CODING = "REVIEW_BULK_CODING",
    REVIEW_SETTINGS = "REVIEW_SETTINGS",

    DOCUMENT_REPORTS = "DOCUMENT_REPORTS",
    PROJECT_MONITORING_ACCESS = "PROJECT_MONITORING_ACCESS",
    EXPORT_STREAM = "EXPORT_STREAM",
    CREATE_CUSTODIANS = "CREATE_CUSTODIANS",
    DISCARD_PILE = "DISCARD_PILE",
    COMPARISONS = "COMPARISONS",
    PROFILES = "PROFILES",
    PROJECT_PREFERENCES = "PROJECT_PREFERENCES",
    EMAIL_DELIVERY = "EMAIL_DELIVERY",
    PROJECT_MEMBERS = "PROJECT_MEMBERS",
    PROJECT_DATA_AREA = "PROJECT_DATA_AREA",
    EXPORT_DATA_AREA = "EXPORT_DATA_AREA",
    SHARED_DATA_SET = "SHARED_DATA_SET",

    USERS = "USERS",
    GROUPS = "GROUPS",
    CONTAINER_KEY_FILES = "CONTAINER_KEY_FILES",
    PRJ_ALIAS_LISTS = "PRJ_ALIAS_LISTS",
    PRJ_ANALYTIC_SETTINGS = "PRJ_ANALYTIC_SETTINGS",
    PRJ_BILLING_REPORTS = "PRJ_BILLING_REPORTS",
    PRJ_CUSTOM_FIELDS = "PRJ_CUSTOM_FIELDS",
    PRJ_DOMAIN_LISTS = "PRJ_DOMAIN_LISTS",
    PRJ_EXCLUDED_CONTENT = "PRJ_EXCLUDED_CONTENT",
    PRJ_EXPORT_FIELDS = "PRJ_EXPORT_FIELDS",
    PRJ_EXPORT_SETTINGS = "PRJ_EXPORT_SETTINGS",
    PRJ_INDEX_SETTINGS = "PRJ_INDEX_SETTINGS",
    PRJ_LOADFILE_SETTINGS = "PRJ_LOADFILE_SETTINGS",
    PRJ_METADATA_SEARCH_FIELDS = "PRJ_METADATA_SEARCH_FIELDS",
    PRJ_METADATA_VIEW_FIELDS = "PRJ_METADATA_VIEW_FIELDS",
    PRJ_PASSWORD_CRACKING = "PRJ_PASSWORD_CRACKING",
    PRJ_REGULAR_EXPRESSIONS = "PRJ_REGULAR_EXPRESSIONS",
    PRJ_REPORT_SETTINGS = "PRJ_REPORT_SETTINGS",
    PRJ_SEARCH_SETTINGS = "PRJ_SEARCH_SETTINGS",
    PRJ_SURVIVORSHIP_SETTINGS = "PRJ_SURVIVORSHIP_SETTINGS",
    PRJ_TAGS = "PRJ_TAGS",
    REALM_NODES = "REALM_NODES",
    OCR_USAGE_REPORT = "OCR_USAGE_REPORT",
    MONITORING = 'MONITORING',
    ORG_ALIAS_LISTS = "ORG_ALIAS_LISTS",
    ORG_ANALYTIC_SETTINGS = "ORG_ANALYTIC_SETTINGS",
    ORG_BILLING_REPORTS = "ORG_BILLING_REPORTS",
    ORG_CUSTOM_FIELDS = "ORG_CUSTOM_FIELDS",
    ORG_DOMAIN_LISTS = "ORG_DOMAIN_LISTS",
    ORG_EXCLUDED_CONTENT = "ORG_EXCLUDED_CONTENT",
    ORG_EXPORT_FIELDS = "ORG_EXPORT_FIELDS",
    ORG_EXPORT_SETTINGS = "ORG_EXPORT_SETTINGS",
    ORG_INDEX_SETTINGS = "ORG_INDEX_SETTINGS",
    ORG_LOADFILE_SETTINGS = "ORG_LOADFILE_SETTINGS",
    ORG_METADATA_SEARCH_FIELDS = "ORG_METADATA_SEARCH_FIELDS",
    ORG_METADATA_VIEW_FIELDS = "ORG_METADATA_VIEW_FIELDS",
    ORG_REGULAR_EXPRESSIONS = "ORG_REGULAR_EXPRESSIONS",
    ORG_REPORT_SETTINGS = "ORG_REPORT_SETTINGS",
    ORG_SEARCH_SETTINGS = "ORG_SEARCH_SETTINGS",
    ORG_SURVIVORSHIP_SETTINGS = "ORG_SURVIVORSHIP_SETTINGS",
    ORG_TAGS = "ORG_TAGS",
    ORG_WORKFLOWS = "ORG_WORKFLOWS",
    REVIEW_SET = "REVIEW_SET",
    DOCUMENT_FOLDER = "DOCUMENT_FOLDER",
    DOCUMENT_CUSTODIAN = "DOCUMENT_CUSTODIAN",
    DOWNLOAD_PDF = "DOWNLOAD_PDF",
    LOCK_UNLOCK_WORKFLOW = "LOCK_UNLOCK_WORKFLOW",
    CONNECTOR_ACCESS = "CONNECTOR_ACCESS",
    ACTIVE_USER_SESSIONS = "ACTIVE_USER_SESSIONS",
    PROJECT_ACCESS_LOG = "PROJECT_ACCESS_LOG",
    DELETE_PENDING_PROJECTS = "DELETE_PENDING_PROJECTS",
    DELETED_PROJECTS = "DELETED_PROJECTS",
    EMAIL_SERVER_AND_NOTIFICATIONS = "EMAIL_SERVER_AND_NOTIFICATIONS",
    JOB_AND_ERROR_HISTORY = "JOB_AND_ERROR_HISTORY",
    JOB_MANAGEMENT = "JOB_MANAGEMENT",
    LICENSE = "LICENSE",
    PASSWORD_AND_USER_LOGOUT_POLICY = "PASSWORD_AND_USER_LOGOUT_POLICY",
    PROJECTS = "PROJECTS",
    SYSTEM_ANALYTIC_SETTINGS = "SYSTEM_ANALYTIC_SETTINGS",
    SYSTEM_BILLING_REPORTS = "SYSTEM_BILLING_REPORTS",
    SYSTEM_DOMAIN_LISTS = "SYSTEM_DOMAIN_LISTS",
    SYSTEM_EXCLUDED_CONTENT = "SYSTEM_EXCLUDED_CONTENT",
    SYSTEM_EXPORT_FIELDS = "SYSTEM_EXPORT_FIELDS",
    SYSTEM_EXPORT_SETTINGS = "SYSTEM_EXPORT_SETTINGS",
    SYSTEM_GROUP = "SYSTEM_GROUP",
    SYSTEM_INDEX_SETTINGS = "SYSTEM_INDEX_SETTINGS",
    SYSTEM_MESSAGE = "SYSTEM_MESSAGE",
    SYSTEM_METADATA_SEARCH_FIELDS = "SYSTEM_METADATA_SEARCH_FIELDS",
    SYSTEM_METADATA_VIEW_FIELDS = "SYSTEM_METADATA_VIEW_FIELDS",
    SYSTEM_PATTERNS = "SYSTEM_PATTERNS",
    SYSTEM_REPORTS_SETTINGS = "SYSTEM_REPORTS_SETTINGS",
    SYSTEM_SEARCH_SETTINGS = "SYSTEM_SEARCH_SETTINGS",
    SYSTEM_STORAGE = "SYSTEM_STORAGE",
    SYSTEM_SURVIVORSHIP_MODEL_SETTINGS = "SYSTEM_SURVIVORSHIP_MODEL_SETTINGS",
    SYSTEM_TAG_SETTINGS = "SYSTEM_TAG_SETTINGS",
    SYSTEM_USER = "SYSTEM_USER",
    SYSTEM_ROLE = "SYSTEM_ROLE",
    SYSTEM_META_TEMPLATE = "SYSTEM_META_TEMPLATE",
    VIRUS_DETECTION = "VIRUS_DETECTION",
    STORAGE = 'STORAGE',
    SERVICES = 'SERVICES',
    REEF_REVIEW_CONNECTOR = 'REEF_REVIEW_CONNECTOR',
    SYSTEM_AUDIT_LOG = 'SYSTEM_AUDIT_LOG',

    TLS_OPEN_IN_RELATIVITY = "TLS_OPEN_IN_RELATIVITY",
    TLS_BILLING_OVERVIEW_TAB = "TLS_BILLING_OVERVIEW_TAB",
    TLS_DR_ACCESS = "TLS_DR_ACCESS",
    TLS_VIEW_OTHERS_DATA_SETS = "TLS_VIEW_OTHERS_DATA_SETS",
    TLS_DATA_SET = "TLS_DATA_SET",
    TLS_PROJECT = "TLS_PROJECT",
    TLS_USERS = "TLS_USERS",
    TLS_EXPORT_TO_VIEW = "TLS_EXPORT_TO_VIEW",
    TLS_PROJECT_CONFIG = "TLS_PROJECT_CONFIG",
    TLS_PM_EMAIL_RECIPIENTS = "TLS_PM_EMAIL_RECIPIENTS",
    TLS_SALES_EMAIL_RECIPIENTS = "TLS_SALES_EMAIL_RECIPIENTS",
    REEF_EXPRESS_PREFERENCES = "REEF_EXPRESS_PREFERENCES"
}

export class ObjectActionSet extends DrEntity {
    type: ObjectActionListType;
    actions: Array<ActionType>;

    constructor(value?: Partial<ObjectActionSet>) {
        super(value);
        if (value) {
            Object.assign(this, value);
        }
    }
}

export class PermissionSet {
    permissionType: ObjectActionListType;
    permissionActions?: ActionType[];
    isMandatory?: boolean;

    constructor(value?: Partial<PermissionSet>) {
        if (!value.permissionActions) {
            value.permissionActions = [ActionType.VIEW];
        }
        if (value) {
            Object.assign(this, value);
        }
    }
}

export abstract class SecureObject {
    permissions: PermissionSet[];
    permissionsGetter: (item: any) => PermissionSet[];
    atLeastOne: boolean;

    constructor(value?: Partial<SecureObject>) {
        if (value) {
            Object.assign(this, value);
        }
    }
}

export const Permissions = {
    userPermissions: new Map<ObjectActionListType, Array<ActionType>>(),
    hasOrgSettingsPermissions: false,
    hasPrjSettingsPermissions: false,
    hasSysSettingsPermissions: false,

    setPermissions(data: Array<ObjectActionSet>): boolean {
        Permissions.clearPermissions();
        const map = Permissions.mapFromObjectActionList(data);
        if (map) {
            Permissions.userPermissions = map;
            Permissions.hasOrgSettingsPermissions =
                Permissions.checkOrgPrjSettingsPermissions("ORG_");
            Permissions.hasPrjSettingsPermissions =
                Permissions.checkOrgPrjSettingsPermissions("PRJ_");
            Permissions.hasSysSettingsPermissions =
                Permissions.checkOrgPrjSettingsPermissions("SYSTEM_");
            return true;
        }
        return false;
    },

    clearPermissions(): void {
        Permissions.userPermissions.clear();
        Permissions.hasOrgSettingsPermissions = false;
        Permissions.hasPrjSettingsPermissions = false;
    },

    // atLeastOne = true          - it will check if the user it has at least one permission type from the passed permissions list  e.g.checking for org settings permissions
    // default atLeastOne = false - it will check if the user has all permissions from the passed list
    // systemUserPermissions: Map<ObjectActionListType, Array<ActionType>> - check for all of the avaiable system user permissions if the logged in user is a system user
    checkUserPermissions(
        permissions: PermissionSet[],
        atLeastOne = false,
        systemUserPermissions: Map<
            ObjectActionListType,
            Array<ActionType>
        > = null
    ): boolean {
        const currentPermissions = Permissions.userPermissions;
        if (permissions && currentPermissions) {
            let allow = true;
            const listOfMandatoryPerm =
                permissions.length > 1
                    ? permissions.filter((p) => p.isMandatory)
                    : null;
            let mandatoryWithAccess = 1;
            let hasMandatoryPermissions =
                listOfMandatoryPerm && listOfMandatoryPerm.length > 0;
            for (const set of permissions) {
                if (currentPermissions.has(set.permissionType)) {
                    if (isUndefined(set.permissionActions)) {
                        // if actions not set default to VIEW action
                        set.permissionActions = [ActionType.VIEW];
                    }
                    const hasActionSet = _.every(
                        set.permissionActions,
                        (action) =>
                            currentPermissions
                                .get(set.permissionType)
                                .includes(action)
                    );
                    if (atLeastOne) {
                        allow = hasActionSet;
                    } else {
                        if (!hasActionSet) {
                            allow = false;
                        }
                    }
                } else {
                    allow = false;
                }
                if (allow && atLeastOne && !hasMandatoryPermissions) {
                    break;
                }
                if (hasMandatoryPermissions && set.isMandatory) {
                    if (!allow) {
                        return false;
                    }
                    if (mandatoryWithAccess === listOfMandatoryPerm.length) {
                        hasMandatoryPermissions = false;
                    } else {
                        mandatoryWithAccess++;
                    }
                }
            }
            return allow;
        }
        return false;
    },

    checkUserPermission(
        permissionType: ObjectActionListType,
        action: ActionType = ActionType.VIEW,
        systemUserPermissions: Map<
            ObjectActionListType,
            Array<ActionType>
        > = null
    ): boolean {
        const currentPermissions = systemUserPermissions
            ? systemUserPermissions
            : Permissions.userPermissions;
        if (
            permissionType &&
            action &&
            currentPermissions.has(permissionType)
        ) {
            return currentPermissions.get(permissionType).includes(action);
        }
        return false;
    },

    checkOrgPrjSettingsPermissions(
        entityPrefix: string,
        systemUserPermissions: Map<
            ObjectActionListType,
            Array<ActionType>
        > = null
    ): boolean {
        let hasPermissions = false;
        switch (entityPrefix) {
            // check if it has at least one project general settings permission
            case "PRJ_": {
                hasPermissions = Permissions.checkUserPermissions(
                    [
                        { permissionType: ObjectActionListType.EMAIL_DELIVERY },
                        {
                            permissionType:
                                ObjectActionListType.PROJECT_MEMBERS,
                        },
                        {
                            permissionType:
                                ObjectActionListType.PROJECT_PREFERENCES,
                        },
                        { permissionType: ObjectActionListType.PRJ_TAGS },
                    ],
                    true,
                    systemUserPermissions
                );
                break;
            }
            // check if it has at least one org general settings permissions
            case "ORG_": {
                hasPermissions = Permissions.checkUserPermissions(
                    [
                        { permissionType: ObjectActionListType.CONNECTOR },
                        {
                            permissionType:
                                ObjectActionListType.PROJECT_DATA_AREA,
                        },
                        {
                            permissionType:
                                ObjectActionListType.EXPORT_DATA_AREA,
                        },
                        {
                            permissionType:
                                ObjectActionListType.SHARED_DATA_SET,
                        },
                        {
                            permissionType:
                                ObjectActionListType.EXPORT_DB_CONNECTION,
                        },
                        { permissionType: ObjectActionListType.USERS },
                        { permissionType: ObjectActionListType.GROUPS },
                        { permissionType: ObjectActionListType.ROLE },
                        {
                            permissionType:
                                ObjectActionListType.CONTAINER_KEY_FILES,
                        },
                        { permissionType: ObjectActionListType.ORG_TAGS },
                    ],
                    true,
                    systemUserPermissions
                );
                break;
            }
            // check if it has at least one system general settings permissions
            case "SYSTEM_": {
                hasPermissions = Permissions.checkUserPermissions(
                    [
                        { permissionType: ObjectActionListType.PROJECTS },
                        {
                            permissionType:
                                ObjectActionListType.PASSWORD_AND_USER_LOGOUT_POLICY,
                        },
                        {
                            permissionType:
                                ObjectActionListType.DELETE_PENDING_PROJECTS,
                        },
                        {
                            permissionType:
                                ObjectActionListType.VIRUS_DETECTION,
                        },
                        {
                            permissionType:
                                ObjectActionListType.DELETED_PROJECTS,
                        },
                        {
                            permissionType:
                                ObjectActionListType.EMAIL_SERVER_AND_NOTIFICATIONS,
                        },
                        {
                            permissionType:
                                ObjectActionListType.LICENSE
                        },
                        {
                            permissionType:
                                ObjectActionListType.VIRUS_DETECTION,
                        },
                        {
                            permissionType:
                                ObjectActionListType.REALM_NODES,
                        }
                    ],
                    true,
                    systemUserPermissions
                );
                break;
            }
        }
        // check if it has at least one org/prj/system template settings permissions
        if (!hasPermissions) {
            for (const value in ObjectActionListType) {
                if (value.includes(entityPrefix)) {
                    hasPermissions = Permissions.checkUserPermission(
                        <ObjectActionListType>value,
                        ActionType.VIEW,
                        systemUserPermissions
                    );
                    if (hasPermissions) {
                        break;
                    }
                }
            }
        }
        return hasPermissions;
    },

    getUserPermissions(
        permissionType: ObjectActionListType
    ): Array<ActionType> {
        if (permissionType && Permissions.userPermissions.has(permissionType)) {
            return Permissions.userPermissions.get(permissionType);
        }
    },

    mapToObjectActionList(
        map: Map<ObjectActionListType, Array<ActionType>>
    ): Array<ObjectActionSet> {
        if (map && map.size) {
            const data = Array.from(map.entries()).map(
                (e) => new ObjectActionSet({ type: e[0], actions: e[1] })
            );
            return data;
        }
    },

    mapFromObjectActionList(
        data: Array<ObjectActionSet>
    ): Map<ObjectActionListType, Array<ActionType>> {
        const map = new Map<ObjectActionListType, Array<ActionType>>();
        if (data && data.length) {
            data.forEach((element) => {
                map.set(element.type, element.actions);
            });
        }
        return map;
    },

    getOrgObjectListTypeForTemplateType(
        tempType: TemplateType
    ): ObjectActionListType {
        switch (tempType) {
            case TemplateType.ANALYTICAL_SETTINGS:
                return ObjectActionListType.ORG_ANALYTIC_SETTINGS;
            case TemplateType.BILLING_REPORT_SETTINGS:
                return ObjectActionListType.ORG_BILLING_REPORTS;
            case TemplateType.DOMAIN_LISTS:
                return ObjectActionListType.ORG_DOMAIN_LISTS;
            case TemplateType.EMAIL_SIGNATURE:
                return ObjectActionListType.ORG_EXCLUDED_CONTENT;
            case TemplateType.EXPORT_FIELDS:
                return ObjectActionListType.ORG_EXPORT_FIELDS;
            case TemplateType.EXPORT_SETTINGS:
                return ObjectActionListType.ORG_EXPORT_SETTINGS;
            case TemplateType.INDEX_SETTINGS:
                return ObjectActionListType.ORG_INDEX_SETTINGS;
            case TemplateType.DOCUMENT_METADATA:
                return ObjectActionListType.ORG_METADATA_VIEW_FIELDS;
            case TemplateType.SEARCH_FIELDS:
                return ObjectActionListType.ORG_METADATA_SEARCH_FIELDS;
            case TemplateType.USER_EXP:
                return ObjectActionListType.ORG_REGULAR_EXPRESSIONS;
            case TemplateType.REPORT_SETTINGS:
                return ObjectActionListType.ORG_REPORT_SETTINGS;
            case TemplateType.SEARCH_SETTINGS:
                return ObjectActionListType.ORG_SEARCH_SETTINGS;
            case TemplateType.DUPE_SURVIVORSHIP:
                return ObjectActionListType.ORG_SURVIVORSHIP_SETTINGS;
            case TemplateType.TAG:
                return ObjectActionListType.ORG_TAGS;
            case TemplateType.WORKFLOWS:
                return ObjectActionListType.ORG_WORKFLOWS;
            default:
                return null;
        }
    },

    getSystemObjectListTypeForTemplateType(
        tempType: TemplateType
    ): ObjectActionListType {
        switch (tempType) {
            case TemplateType.META_TEMPLATE_PROFILE:
                return ObjectActionListType.SYSTEM_META_TEMPLATE;
            case TemplateType.ANALYTICAL_SETTINGS:
                return ObjectActionListType.SYSTEM_ANALYTIC_SETTINGS;
            case TemplateType.BILLING_REPORT_SETTINGS:
                return ObjectActionListType.SYSTEM_BILLING_REPORTS;
            case TemplateType.DOMAIN_LISTS:
                return ObjectActionListType.SYSTEM_DOMAIN_LISTS;
            case TemplateType.EMAIL_SIGNATURE:
                return ObjectActionListType.SYSTEM_EXCLUDED_CONTENT;
            case TemplateType.EXPORT_FIELDS:
                return ObjectActionListType.SYSTEM_EXPORT_FIELDS;
            case TemplateType.EXPORT_SETTINGS:
                return ObjectActionListType.SYSTEM_EXPORT_SETTINGS;
            case TemplateType.INDEX_SETTINGS:
                return ObjectActionListType.SYSTEM_INDEX_SETTINGS;
            case TemplateType.DOCUMENT_METADATA:
                return ObjectActionListType.SYSTEM_METADATA_VIEW_FIELDS;
            case TemplateType.SEARCH_FIELDS:
                return ObjectActionListType.SYSTEM_METADATA_SEARCH_FIELDS;
            case TemplateType.USER_EXP:
                return ObjectActionListType.SYSTEM_PATTERNS;
            case TemplateType.REPORT_SETTINGS:
                return ObjectActionListType.SYSTEM_REPORTS_SETTINGS;
            case TemplateType.SEARCH_SETTINGS:
                return ObjectActionListType.SYSTEM_SEARCH_SETTINGS;
            case TemplateType.DUPE_SURVIVORSHIP:
                return ObjectActionListType.SYSTEM_SURVIVORSHIP_MODEL_SETTINGS;
            case TemplateType.TAG:
                return ObjectActionListType.SYSTEM_TAG_SETTINGS;
            default:
                return null;
        }
    },
};
